import { AthleteOverviewProviderType } from "@/components/athlete-overview-page/athlete-overview-page-provider/types";
import { AthleteOverviewPageViewProps } from "@/components/athlete-overview-page/athlete-overview-page-view";
import { createContext, useContext, useState } from "react";
import { SearchParamsProps } from "../athlete-overview-page-view/types";
import { PdfUrlProps } from "@/components/athlete-overview-page/athlete-table/types";
import UseUrlParams from "@/hooks/use-search-params";


export const athleteOverviewContext = createContext<AthleteOverviewProviderType>({
    data: {
        sponsorBanner: {
            imageUrl: '',
            imageAltText: '',
            imageLink: ''
        },
        athleteTable: {
            athletes: [],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                totalPages: 1
            },
            pdfUrl: {} as PdfUrlProps
        },
        podium: [],
        searchParams: {} as SearchParamsProps,
        lowestYear: 2022,
        selectedAthlete: null
    },
    updateSearchParams: () => { }
});

export function AthleteOverviewProvider({ children, initial }: {
    children: React.ReactNode;
    initial: AthleteOverviewPageViewProps
}) {
    const { updateUrlParams } = UseUrlParams()
    const sponsorBanner = {
        imageUrl: initial.sponsorBanner?.imageUrl || '',
        imageAltText: initial.sponsorBanner?.imageAltText || '',
        imageLink: initial.sponsorBanner?.imageLink || ''
    }
    const lowestYear = initial.lowestYear
    const [data, setData] = useState<AthleteOverviewPageViewProps>(initial);

    const updateData = (partial: Partial<AthleteOverviewPageViewProps>) => {
        setData((prev) => ({
            ...prev,
            ...partial,
            sponsorBanner,
            lowestYear
        }));
    }

    const getNewData = async (params: SearchParamsProps) => {
        try {
            const res = await fetch("/api/athleteapi/season", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(params),
            });

            if (!res.ok) throw new Error("Failed to fetch athlete overview data");

            const json = await res.json();

            if (!params.fisCode) json.selectedAthlete = null;

            updateData(json);
        } catch (err) {
            console.error("Error updating athlete data", err);
        }
    };

    const updateSearchParams = (params: Record<string, any>) => {
        updateUrlParams(params);
        const newParams = { ...data.searchParams, ...params }
        getNewData(newParams);
    }

    return (
        <athleteOverviewContext.Provider value={{ data, updateSearchParams }}>
            {children}
        </athleteOverviewContext.Provider>

    )
}

export const UseAthleteOverview = () => {
    const context = useContext(athleteOverviewContext)
    if (!context) throw new Error("UseAthleteOverview is not inside an AthleteOverviewProvider")
    return context
}